import message from '../../../lib/message';
export default message;
